export function getActiveSpectrum(state) {
    const { activeSpectra, activeTab } = state.view.spectra;
    return activeSpectra[activeTab] || null;
}
